// extracted by mini-css-extract-plugin
module.exports = {"form":"styles__form___3u7Bj","private":"styles__private___3XB-l"};